<script setup lang="ts">
import type { Benefits_Plain } from '@webamboos/admin/src/components/sections/interfaces/Benefits'

const props = defineProps<{
  benefit: Benefits_Plain
}>()
</script>

<template>
  <div
    class="hover:bg-main-50 group cursor-pointer rounded-lg border border-gray-200 bg-white p-4 shadow-lg transition-all duration-300 ease-in-out hover:shadow-[0_0_0_2px_#2AAEA3]"
  >
    <div class="mb-4 flex items-center">
      <div class="bg-main-50 flex items-center justify-center rounded-full p-2">
        <div
          class="bg-main-100 text-main-700 group-hover:bg-main-500 flex h-12 w-12 items-center justify-center rounded-full border transition-all duration-300 ease-in-out group-hover:text-white"
        >
          <Icon class="h-6 w-6" :name="props.benefit.icon!" />
        </div>
      </div>
    </div>
    <Heading size="small" class="mb-4">
      {{ props.benefit.title }}
    </Heading>
    <p class="pb-6 text-sm text-gray-600">
      <RichText :raw="props.benefit.description || ''" />
    </p>
  </div>
</template>
